<template>
  <div class='lib__form__main' data-cy='identification-component'>
    <div class='lib__form__main__content'>
      <header class='lib__form__main__header'>
        <h2 class='lib__h2'>{{ $t('identification.smartMeter.title') }}</h2>
      </header>
      <ValidationObserver ref='validator' slim>
        <Identification @canContinue='canContinue($event)' @eanCode='eanCode = $event' @gridAccessPoint='gridAccessPoint = $event'
                        @isIdentified='isIdentified = $event' />
        <IdentificationConfirmation v-if='isIdentified && gridAccessPoint' :eanCode='eanCode' :grid-access-point='gridAccessPoint' />
      </ValidationObserver>

    </div>
  </div>
</template>

<script lang='ts'>
import Step from '@/components/steps/Step'
import Identification from '@/components/inputs/ChargingStationDeclaration/Identification.vue'
import IdentificationConfirmation from '@/components/inputs/ChargingStationDeclaration/IdentificationConfirmation.vue'
import Component from 'vue-class-component'
import { ChargingStationDeclarationGridAccessPoint } from '@/models'
import { State } from 'vuex-class'

@Component({
  name: 'identification-step',
  components: {
    Identification,
    IdentificationConfirmation
  }
})
export default class IdentificationStep extends Step {
  //#region [Data]
  @State('requestId', { namespace: 'chargingStationDeclaration' })
  public requestId!: string

  public eanCode: string | null = null
  public gridAccessPoint: ChargingStationDeclarationGridAccessPoint | null = null
  public isIdentified: boolean | null = null
  //#endregion

  //#region [Computed]
  //#endregion

  //#region [Mutation]
  //#endregion

  //#region [Watch]
  //#endregion

  //#region [Method]
  public mounted() {
    this.setIsBack(false)
  }

  public async save(next: boolean, isValid: boolean): Promise<boolean> {

    if (isValid) {
      this.$appInsights.trackEvent('ChargingStationDeclaration_StepIdentification_Validated', {
        Segment: 'ChargingStationDeclaration',
        WebRef: this.requestId,
        ZipCode: this.gridAccessPoint?.consumptionAddress.zipCode ?? ''
      })
    }
    return next && isValid
  }

  //#endregion
}
</script>
